import { render, staticRenderFns } from "./PostApp.vue?vue&type=template&id=ccb5010c&scoped=true"
import script from "./PostApp.vue?vue&type=script&lang=js"
export * from "./PostApp.vue?vue&type=script&lang=js"
import style0 from "./PostApp.vue?vue&type=style&index=0&id=ccb5010c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccb5010c",
  null
  
)

export default component.exports